export function applyCalendarTheme(calendar, source) {
    let parent = source;
    let theme;
    while (parent && !theme) {
        theme = Array.from(parent.classList || []).find(className => /^theme\d+$/.test(className));
        parent = parent.parentElement;
    }

    calendar.classList.add('theme-datepicker');
    calendar.classList.forEach(className => {
        if (/^theme\d+$/.test(className)) calendar.classList.remove(className);
    });
    if (theme) calendar.classList.add(theme);
}

export function bindCalendarOpening(instance) {
    // Open on click on touch screens so the centered calendar cannot catch the
    // same tap that focuses the field. Desktop still opens on keyboard focus.
    instance.set('clickOpens', false);
    const input = instance._input;
    const open = () => instance.open();
    const focus = () => {
        if (window.matchMedia('(min-width: 768px)').matches) instance.open();
    };
    input.addEventListener('click', open);
    input.addEventListener('focus', focus);
    instance.config.onDestroy.push(() => {
        input.removeEventListener('click', open);
        input.removeEventListener('focus', focus);
    });
}
